import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { PatientSerieEvent } from './patient_serie_events';

@Injectable({ providedIn: 'root' })
export class PatientSerieEventProvider extends DomainEventProvider<PatientSerieEvent> {}
